import React from 'react';
import { AlertCircle } from 'react-feather';
import cn from 'classnames';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const IncompleteAssessmentSection = ({
  status,
  error,
  processText,
  invalidValue = false,
}) => {
  const isTranscript = processText === t('automated_analysis.transcript.title');
  const isKeywordMatching =
    processText === t('automated_analysis.keyword_matching.title');
  return (
    <div>
      {!error && (status === 'waiting' || status === 'pending') && (
        <Text className="fs-i ml-16" variant={TEXT_VARIANTS.BODY}>
          {t('automated_analysis.grading_station.processing')}
        </Text>
      )}
      {error && (
        <div
          className={cn('d-f ai-c', {
            'fd-c': !isTranscript && !isKeywordMatching,
          })}
        >
          <AlertCircle className="c-error mr-6" width={16} />
          <Text
            className={cn('c-error mr-10 ml-6')}
            variant={TEXT_VARIANTS.BODY}
          >
            {isTranscript
              ? t('automated_analysis.grading_station.network_error')
              : t('automated_analysis.grading_station.results_unavailable')}
          </Text>
        </div>
      )}
      {!error &&
        (status === 'failed' ||
          status === 'unrecoverable' ||
          (status === 'complete' && invalidValue)) && (
          <div
            className={cn('d-f ai-c', {
              'fd-c': !isTranscript && !isKeywordMatching,
            })}
          >
            <AlertCircle className="c-error mr-6" width={16} />
            <Text className="c-error ml-6" variant={TEXT_VARIANTS.BODY}>
              {isTranscript
                ? t('automated_analysis.grading_station.analysis_failed')
                : t('automated_analysis.grading_station.results_unavailable')}
            </Text>
          </div>
        )}
    </div>
  );
};

export default IncompleteAssessmentSection;
